
import { mapActions, mapGetters } from 'vuex';
import PortfolioIcon from '~/components/ui/icons/PortfolioIcon.vue';
import AddIcon from '~/components/ui/icons/AddIcon.vue';
import ChevronIcon from '~/components/ui/icons/ChevronIcon.vue';
import PortfolioInfo from '@/components/ui/molecule/PortfolioInfo';
import {
  _maxPortfolioLimit,
  _verifiedUserMaxPortfolioLimit,
} from '@/utils/portfolio-settings';
import {
  canCreatePortfolio,
  cannotCreatePortfolioReason,
} from '~/utils/behavior/portfolio-creation';
import { inAppRedirect, appURLs } from '~/utils/route-redirects';
import { FILTER_INTERVAL_KEYS } from '~/utils/filter-intervals';
import { eventManager } from '@/utils/behavior/applicationEvents/event-manager';
import { debounce } from 'lodash';
import { capitalizeFirstLetter } from '@/utils/string-formatter';

export default {
  name: 'HeaderPortfolios',
  components: { PortfolioIcon, AddIcon, PortfolioInfo, ChevronIcon },
  fetchOnServer: false,
  data() {
    return {
      showPortfolioDropdownList: false,
      portfoliosInDropdown: [],
      debouncedRaiseClickMenuPrincipalEvent: debounce(
        (v) => this.raiseClickMenuPrincipalEvent(v),
        300
      ),
    };
  },
  computed: {
    ...mapGetters('portfolio', [
      'getMyPortfoliosRes',
      'myOwnedPortfolios',
      'mySharedPortfolios',
    ]),
    ...mapGetters('authentication', [
      'isEmailConfirmed',
      'profile',
      'isVerifiedInfluencer',
    ]),
    maxPortfolioLimit() {
      if (this.profile.isVerifiedInfluencer)
        return _verifiedUserMaxPortfolioLimit;
      else return _maxPortfolioLimit;
    },
    canCreatePortfolio() {
      return canCreatePortfolio(
        this.isEmailConfirmed,
        this.myOwnedPortfolios.length,
        this.isVerifiedInfluencer
      );
    },
    cannotCreatePortfolioReason() {
      return cannotCreatePortfolioReason(
        this.isEmailConfirmed,
        this.myOwnedPortfolios.length,
        this.isVerifiedInfluencer
      );
    },
  },
  methods: {
    ...mapActions('modals', ['showCreatePortfolioModal']),
    getDropdownListStyle() {
      return 'width: fit-content; top:55px;';
    },
    handleNavigateToPortfolio(portfolioId) {
      inAppRedirect(`/portfolios/${portfolioId}`);
    },
    async handlePortfolioDropdownHover() {
      if (!this.showPortfolioDropdownList) {
        this.debouncedRaiseClickMenuPrincipalEvent('OpenPortfolioDropdown');
        this.portfoliosInDropdown = [];
        this.showPortfolioDropdownList = true;

        if (this.getMyPortfoliosRes?.data?.portfolios)
          for (const portfolio of [
            ...this.myOwnedPortfolios,
            ...this.mySharedPortfolios,
          ]) {
            this.portfoliosInDropdown.push(portfolio);
            await new Promise((r) => setTimeout(r, 20));
          }
      }
    },
    handleAddPortfolio() {
      this.showCreatePortfolioModal();
    },
    handlePortfolioClickWithYTDFilter(portfolioId) {
      this.raiseClickMenuPrincipalEvent('Portfolio');

      inAppRedirect(
        this.localePath(
          appURLs.portfolioByGraphInterval(
            FILTER_INTERVAL_KEYS.YTD,
            portfolioId
          )
        )
      );
    },
    raiseClickMenuPrincipalEvent(value) {
      eventManager.raiseClickMenuPrincipalEvent({
        text: 'TopNavbar | ' + capitalizeFirstLetter(value),
      });
    },
  },
};
